import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "./axiosInstance";

export const fetchCourseModule = createAsyncThunk(
    'courseModule/fetchCourseModule',
    async ({ uid, subject_name }) => {      
        try {
            const response = await axiosAuth.post('https://ninjacurate.learntube.ai/fetch_user_course_data', { uid: uid, subject_name: subject_name });
            return response.data;
        } catch (err) {
            console.log(err);
            throw err
        }
  }
);

const courseModuleSlice = createSlice({
    name: 'courseModule',
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCourseModule.fulfilled, (state, action) => {
            return action.payload;
        });
    },
});

export const selectCourseModule = (state) => state.personaliseLessons?.courseModule;
export const selectCourseModuleContent = (state) => state.personaliseLessons?.courseModule?.course_data
export default courseModuleSlice.reducer;